<template>
  <v-app-bar app dark clipped-right hide-on-scroll class="so-dark">
    <v-toolbar-title>
      <router-link to="/">
        <img
          width="85"
          class="pt-2"
          :src="require('@/assets/pearl-black.png')"
        />
      </router-link>
    </v-toolbar-title>
    <division-selector></division-selector>
    <main-menu />
    <v-spacer></v-spacer>
    <logout-button></logout-button>
  </v-app-bar>
</template>

<script>
import MainMenu from '@/components/App/MainMenu.vue'
import DivisionSelector from '@/components/App/DivisionSelector.vue'
import LogoutButton from './LogoutButton.vue'
/**
 * This component displays the main application Bar
 */
export default {
  name: 'AppBar',
  components: { MainMenu, DivisionSelector, LogoutButton }
}
</script>

<style scoped>
.theme--dark.v-app-bar.v-toolbar.v-sheet.so-dark {
  background-color: black;
}

.v-toolbar__title {
  width: 110px;
}
</style>
